import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';
import { isCarbonScoreRelevant } from '@/domains/sustainability/carbonScore/utils/validityChecker';

export const useCarbonScore = () => {
  const { carbonScore } = useDetail<'b2c'>();

  if (carbonScore && isCarbonScoreRelevant(carbonScore.product)) {
    return carbonScore;
  }

  return null;
};
